/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBracketsContainStart = createReactComponent("outline", "brackets-contain-start", "IconBracketsContainStart", [["path", { "d": "M9 4h-4v16h4", "key": "svg-0" }], ["path", { "d": "M18 16h-.01", "key": "svg-1" }], ["path", { "d": "M14 16h-.01", "key": "svg-2" }], ["path", { "d": "M10 16h-.01", "key": "svg-3" }]]);

export { IconBracketsContainStart as default };
//# sourceMappingURL=IconBracketsContainStart.mjs.map
